import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {isBlank} from "../../helpers/stringHelper";
import {getLocaleInfoFromLocal} from "../../core/localization/localizationHelper";
import {defaultLocalCode} from "../../core/localization/defaults";


type storeDataType = {
    [key: string]: any[]
};

type languageStoreDictionary = {
    [key: string]: storeDataType,
};

interface StoreSliceModel {
    languageCode: string,
    store:storeDataType,
    allStore: languageStoreDictionary,
}

const initialState: StoreSliceModel = {
    languageCode:getLocaleInfoFromLocal().locale,
    store: {},
    allStore:{}
}

export const localizationStoreSlice = createSlice({
    name: "localizationStore",
    initialState: initialState,
    reducers: {
        setLocalizationStore: (state, action: PayloadAction<{ data: [], key: string }>) => {
            state.store[action.payload.key] = action.payload.data
        },
        setLocalizationStoreWithCode: (state, action: PayloadAction<{ data: [], key: string, languageCode: string }>) => {
            if(state.languageCode === action.payload.languageCode){
                state.store[action.payload.key] = action.payload.data;
            }
            state.store[action.payload.key] = action.payload.data
            if(!state.allStore[state.languageCode]){
                state.allStore[state.languageCode] ={};
            }
            state.allStore[state.languageCode][action.payload.key] = action.payload.data;
        },
        clearStore: (state) => {
            state.store = {};
        },
        changeStoreLanguage: (state, action: PayloadAction<string>) => {
            const languageCode = action.payload ?? defaultLocalCode;
            if(!isBlank(state.languageCode)){
                state.allStore[state.languageCode] = state.store;
            }
            if(state.allStore[languageCode] !== undefined){
                state.store = state.allStore[languageCode];
            }else{
                state.store ={};
            }
            state.languageCode = languageCode;

            return state;
        },
    }
})

export const {setLocalizationStore,setLocalizationStoreWithCode, clearStore,changeStoreLanguage} = localizationStoreSlice.actions;

export default localizationStoreSlice.reducer;
